import { render } from "./ManualAlarmForPlant.vue?vue&type=template&id=3dc09229"
import script from "./ManualAlarmForPlant.vue?vue&type=script&lang=js"
export * from "./ManualAlarmForPlant.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__